import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  DialogActions,
  Dialog,
  Typography,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CustomButton from '../../../../../../../../../lib/designSystem/Button';
import {
  executeRecesion,
  getAECsInPosession,
} from '../../../../../../../../../lib/api/reSell/factoring';
import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';
import CenteredCircularProgress from '../../../../../../../../../lib/designSystem/CircularProgress';
import { showAlert } from '../../../../../../../../../lib/functions/utils';

const CessionDialog = (props: any) => {
  const {
    open,
    setOpen,
    documents,
    bankAccountId,
    setOpenBigDialog,
    setUpMainPage,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [documentsWithStatus, setDocumentsWithStatus] = useState([]);
  const [documentsResult, setDocumentsResult] = useState<any[]>([]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const documentsWithBankAccount = documentsWithStatus.map(
        (document: any) => ({
          ...document,
          bankAccountId,
        }),
      );
      const response = await executeRecesion(dispatch, {
        documentsToResell: documentsWithBankAccount,
      });
      const mergedDocuments = documentsWithStatus.map((document: any) => {
        const responseForDocument = response.results.find(
          (item: any) => item.id === document.id,
        );
        return {
          ...document,
          status: responseForDocument?.status,
          message: responseForDocument?.message,
        };
      });
      setDocumentsResult(mergedDocuments);
      const documentsReselled = mergedDocuments.filter(
        (document: any) => document.status,
      );
      if (documentsReselled.length > 0) {
        const text = `Cesiones generadas correctamente para ${documentsReselled.length} facturas. La cesión demora entre 2 a 10 minutos en ser reflejada en el SII.`;
        showAlert(dispatch, 'success', text);
        await setUpMainPage();
        setOpenBigDialog(false);
        setOpen(false);
      } else {
        showAlert(
          dispatch,
          'error',
          'Error al generar algunas cesiones, por favor verifique los datos',
        );
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al generar cesiones');
    } finally {
      setLoading(false);
    }
  };

  const CheckAecInPosession = async () => {
    try {
      setLoading(true);
      const documentIds = documents.map((document: any) => document.id);
      const response = await getAECsInPosession(dispatch, documentIds);
      const mergedDocuments = documents.map((document: any) => {
        const documentWithStatus = response.find(
          (item: any) => item.id === document.id,
        );
        return {
          ...document,
          status: documentWithStatus?.status,
          message: documentWithStatus?.message,
        };
      });
      setDocumentsWithStatus(mergedDocuments);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const setUpDialog = async () => {
    await CheckAecInPosession();
  };

  useEffect(() => {
    setUpDialog();
  }, []);

  const canMakeCession = documentsWithStatus.every(
    (document: any) => document.status,
  );

  return (
    <Dialog maxWidth="md" fullWidth open={open}>
      <DialogTitle>
        <Typography variant="h6">Cesión de facturas</Typography>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <>
            <Typography variant="body1">
              A continuación se muestran todas las facturas que van a ser
              cedidas
            </Typography>
            {documentsResult.length > 0 ? (
              <EnhancedTable
                data={documentsResult}
                dataHeaders={[
                  {
                    key: 'businessName',
                    label: 'Razón social',
                  },
                  {
                    key: 'businessIdentifier',
                    label: 'RUT',
                  },
                  {
                    key: 'folio',
                    label: 'Folio',
                  },
                  {
                    key: 'fundId',
                    label: 'Fondo',
                  },
                  {
                    key: 'status',
                    label: 'Estado',
                    type: 'yes-no-circle',
                  },
                  {
                    key: 'message',
                    label: 'Mensaje',
                  },
                ]}
              />
            ) : (
              <EnhancedTable
                data={documentsWithStatus}
                dataHeaders={[
                  {
                    key: 'businessName',
                    label: 'Razón social',
                  },
                  {
                    key: 'businessIdentifier',
                    label: 'RUT',
                  },
                  {
                    key: 'folio',
                    label: 'Folio',
                  },
                  {
                    key: 'fundId',
                    label: 'Fondo',
                  },
                  {
                    key: 'status',
                    label: 'Estado',
                    type: 'yes-no-circle',
                  },
                  {
                    key: 'message',
                    label: 'Mensaje',
                  },
                ]}
              />
            )}
          </>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions>
          <CustomButton onClick={() => setOpen(false)} color="secondary">
            Salir
          </CustomButton>
          <CustomButton
            disabled={!canMakeCession}
            onClick={() => handleSubmit()}
            color="primary"
          >
            Confirmar
          </CustomButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CessionDialog;
